import React, { useEffect } from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Modal, ModalBody, ModalCloseBtn, ModalContent, ModalFooter, ModalHeader } from '@fiverr-private/overlay';
import { Typography } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { colorWhite } from '@fiverr-private/sass/helpers';
import { Video } from '@fiverr-private/media';
import { Button } from '@fiverr-private/button';
import { CalendarIcon } from '@fiverr-private/icons';
import { IPrimaryCommonProps } from '@fiverr-private/primary_section_sdk';
import {
    clickedOnFindOutMore,
    clickedOnModalClose,
    clickedOnScheduleMeeting,
    viewedPjpScheduleModal,
} from './biqQueryEvents';

export interface ProjectManagementModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const ProjectManagementModal = ({
    isOpen,
    onClose,
    reportClick,
}: ProjectManagementModalProps & IPrimaryCommonProps) => {
    const source = 'fiverr_lihp';
    const onScheduleMeetingClick = async () => {
        clickedOnScheduleMeeting();
        reportClick({
            page_element_name: 'project_management_modal_schedule_meeting',
        });
    };
    const onFindOutClick = () => {
        clickedOnFindOutMore();
        reportClick({ page_element_name: 'project_management_modal_find_out_more' });
    };
    const handleClose = () => {
        clickedOnModalClose();
        reportClick({ page_element_name: 'project_management_modal_close' });
        onClose();
    };

    useEffect(() => {
        if (isOpen) {
            viewedPjpScheduleModal();
        }
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={handleClose} fullScreenBreakpoint="sm">
            <ModalContent size="sm">
                <ModalHeader>
                    <ModalCloseBtn />
                </ModalHeader>
                <ModalBody>
                    <Stack direction="column" alignItems="flexStart">
                        <Video
                            sources={[
                                {
                                    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/cb75ee4d7599ecd0b7415ca62d5c3d51-1733992840119/PjM%20Walktrough%20with%20tumbnail%20first%20second',
                                    type: 'video/mp4',
                                },
                            ]}
                        />
                        <Typography fontSize={{ default: 'b_lg', md: 'b_xxl' }} fontWeight="bold" color="grey_1200">
                            <I18n k="primary_project_management.modal.title" />
                        </Typography>
                        <Typography color="grey_1100">
                            <I18n k="primary_project_management.modal.subtitle" />
                        </Typography>
                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button
                        target="_blank"
                        onClick={onFindOutClick}
                        href={`/cp/project-management?source=${source}`}
                        variant="outline"
                        intent="secondary"
                    >
                        <I18n k="primary_project_management.modal.find_out_cta" />
                    </Button>
                    <Button
                        target="_blank"
                        onClick={onScheduleMeetingClick}
                        href={`https://meetings-eu1.hubspot.com/rachael-loiseau/project-management-fiverr-pro-lihp?uuid=2ba11ecb-3533-4bb1-9fec-cf9993ec639a&utm_source=${source}`}
                    >
                        <CalendarIcon color={colorWhite} />
                        <I18n k="primary_project_management.modal.schedule_cta" />
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ProjectManagementModal;
